import { render, staticRenderFns } from "./balance-pill.vue?vue&type=template&id=6834e68d"
import script from "./balance-pill.vue?vue&type=script&lang=js"
export * from "./balance-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports